 <template>
  <div :class="`m-portal m-portal-${routeType}-page`">
    <portal-nav-top :activeIndex="3"></portal-nav-top>
    <div id="ljh-culture">
      <div class="container-fluid" style="width:1100px;">
        <el-row :gutter="20">
          <el-col :span="6" class="left-menu-wrap">
            <portal-dest-nav
              v-if="['yjgl','720','3d','vr','xcgh'].indexOf($route.params._field)>-1"
            ></portal-dest-nav>
            <portal-cult-nav v-else></portal-cult-nav>
          </el-col>
          <el-col :span="18" class="content-page-wrap">
            <div class="content-page">
              <div class="navigation">
                <span>首页</span>
                <span>&nbsp;>&nbsp;</span>
                <span v-if="['3d','720','vr','yjgl'].indexOf($route.params._field)>-1">文化旅游</span>
                <span v-else>文化概述</span>
                <span>&nbsp;>&nbsp;</span>
                <span>{{title[$route.params._field]}}</span>
              </div>
              <bs-list-yicuntype
                :filter="filter"
                :meta="{ module:'article-yicun-type',field:'list' }"
                :is-loading="true"
                v-if="['whyc_page'].indexOf($route.params._field)>-1">
                <template slot="data" slot-scope="slot">
                  <div class="head-select">
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <div class="grid-content bg-purple">
                          <span class="address">类别选择:</span>
                          <ul>
                            <li
                              v-bind:class="{'selected': selectedType==''}"
                              v-on:click="selectType({yicunType:''})"
                            >
                              <a class="font-size">不限</a>
                            </li>
                            <!-- <li
                              v-for="(item,index) in slot.data"
                              :key="index"
                              v-bind:class="{'selected':    selectedType  == item.yicunType}"
                              v-on:click="selectType(item)"
                              v-show="item.yicunType!='其它遗存'"
                            >
                              <a class="font-size">{{item.yicunType}}</a>
                            </li> -->
                            <li
                              v-bind:class="{'selected': selectedType=='书院遗存'}"
                              v-on:click="selectType({yicunType:'书院遗存'})"
                            >
                              <a class="font-size">书院遗存</a>
                            </li>
                            <li
                              v-bind:class="{'selected': selectedType=='建筑遗存'}"
                              v-on:click="selectType({yicunType:'建筑遗存'})"
                            >
                              <a class="font-size">建筑遗存</a>
                            </li>
                            <li
                              v-bind:class="{'selected': selectedType=='碑崖遗存'}"
                              v-on:click="selectType({yicunType:'碑崖遗存'})"
                            >
                              <a class="font-size">碑崖遗存</a>
                            </li>
                            <li
                              v-bind:class="{'selected': selectedType=='匾联遗存'}"
                              v-on:click="selectType({yicunType:'匾联遗存'})"
                            >
                              <a class="font-size">匾联遗存</a>
                            </li>
                            <li
                              v-bind:class="{'selected': selectedType=='其他遗存'}"
                              v-on:click="selectType({yicunType:'其他遗存'})"
                            >
                              <a class="font-size">其他遗存</a>
                            </li>
                          </ul>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </template>
              </bs-list-yicuntype>

              <div class="article-list">
                <bs-page :filter="filter" :meta="meta" ref="refId" content-class>
                  <template slot="data" slot-scope="slot">
                    <portal-arti-page-video
                      v-if="['vr'].indexOf($route.params._field)>-1"
                      :result="slot"
                    ></portal-arti-page-video>
                    <portal-arti-page-url
                      v-if="['3d'].indexOf($route.params._field)>-1"
                      :result="slot"
                    ></portal-arti-page-url>
                    <portal-arti-page-dest
                      v-if="['yjgl'].indexOf($route.params._field)>-1"
                      :result="slot"
                    ></portal-arti-page-dest>
                    <portal-arti-page-kw
                      v-if="['kw'].indexOf($route.params._field)>-1"
                      :result="slot"
                    ></portal-arti-page-kw>
                    <portal-arti-page-720
                      v-if="['720'].indexOf($route.params._field)>-1"
                      :result="slot"
                    ></portal-arti-page-720>
                    <portal-arti-page-picture
                      v-if="['zzln','jysx','zzlx','zzsj','jdxb','zzgs','zzcp'].indexOf($route.params._field)>-1"
                      :result="slot"
                    ></portal-arti-page-picture>
                    <portal-arti-page-whyc
                      v-if="['whyc_page'].indexOf($route.params._field)>-1"
                      :result="slot"
                    ></portal-arti-page-whyc>
                    <portal-arti-page-whjt
                      v-if="['whjt_page'].indexOf($route.params._field)>-1"
                      :result="slot"
                    ></portal-arti-page-whjt>
                    <portal-arti-page-zzsl
                      v-if="['zzsl_page'].indexOf($route.params._field)>-1"
                      :result="slot"
                    ></portal-arti-page-zzsl>
                  </template>
                  <template slot="empty">
                    <div>
                      <img src="../../assets/portal/zwsj.png" style="width:100%;height:300px" />
                    </div>
                  </template>
                  <template slot="paging" slot-scope="slot">
                    
                    <el-pagination
                      background
                      v-if="slot.data.totalCount>20"
                      style="float:clear; clear:both;margin:0 auto;text-align: center"
                      layout="prev, pager, next"
                      @size-change="pageSizeChange"
                      @current-change="pageIndexChange"
                      :current-page="filter.pageIndex"
                      :page-size="filter.pageSize"
                      :total="slot.data.totalCount"
                    ></el-pagination>
                  </template>
                </bs-page>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <portal-footer></portal-footer>
  </div>
</template>
<script>
</script>
<script>
//$('body,html').animate({scrollTop:0},800);
require("../../styles/portal/culture.scss");
export default {
  data() {
    return {
      selectedType: "",
      routeType: "arti",
      title: {
        "3d": "虚拟体验",
        "720": "全景浏览",
        vr: "全景视频",
        song: "朱子之歌",
        yjgl: "游记攻略",
        jdxb: "经典选编",
        whyc: "文化遗存",
        whyc_page: "文化遗存",
        whjt_page: "文化讲坛",
        zzsl_page: "朱子四礼",
        whyc_detail: "文化遗存",
        kw: "朱子刊物",
        whjt: "文化讲坛",
        jysx: "教育思想",
        "life-resume": "朱子生平",
        zzln: "政治理念",
        zzlx: "朱子理学",
        zzcp: "朱子产品",
        zzsl: "朱子四礼",
        zzsj: "政治实践",
        zzgs: "朱子故事",
        xcgh: "行程规划"
      },
      culture: true,
      travel: false,
      picture: false,
      picture5: false,
      dest: false,
      picture3: true,
      url: false,
      vr: false,
      meta: {
        module: this.$route.params._module,
        field: this.$route.params._field
      },
      filter: {
        pageIndex: 1,
        pageSize: 20,
        yicunType: ""
      },
      api: null
    };
  },
  mounted() {},
  props: {
    routeWatch: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BsListYicuntype: () => import("../../components/bs-list-yicuntype"),
    BsList: () => import("../../components/bs-list"),
    BsPage: () => import("../../components/bs-page"),
    PortalNavTop: () => import("./portal-nav-top"),
    PortalNavLeft: () => import("./portal-nav-left"),
    PortalArtiPagePicture5: () => import("./portal-arti-page-picture5"),
    PortalArtiPageVideo: () => import("./portal-arti-page-video"),
    PortalArtiPage720: () => import("./portal-arti-page-720"),
    PortalArtiPageWhjt: () => import("./portal-arti-page-whjt"),
    PortalArtiPageWhyc: () => import("./portal-arti-page-whyc"),
    PortalArtiPageUrl: () => import("./portal-arti-page-url"),
    PortalArtiPageZzsl: () => import("./portal-arti-page-zzsl"),
    PortalArtiPageDest: () => import("./portal-arti-page-dest"),
    PortalArtiPageKw: () => import("./portal-arti-page-kw"),
    // PortalArtiPagePicture2: () => import("./portal-arti-page-picture2"),
    // PortalArtiPagePicture3: () => import("./portal-arti-page-picture3"),
    PortalArtiPagePicture: () => import("./portal-arti-page-picture"),
    PortalDestNav: () => import("./portal-dest-nav"),
    PortalCultNav: () => import("./portal-cult-nav"),
    PortalFooter: () => import("./portal-footer")
  },
  methods: {
    selectType: function(item) {
      this.selectedType = item.yicunType;
      this.filter.yicunType = item.yicunType;
      this.$refs["refId"].loadData();
    },
    handleChangeData() {},
    handleDetail(item) {
      let _module = this.$route.params._module;
      let _field = this.$route.params._field;
      this.$router.push({
        path: `/portal/arti/detail/${_module}/${_field}_detail/${item.artiId}`
      });
    },
    pageSizeChange(val) {
      let that = this;
      that.filter.pageSize = val;
      this.$refs["refId"].loadData();
    },
    pageIndexChange(val) {
      let that = this;
      that.filter.pageIndex = val;
      this.$refs["refId"].loadData();
    }
  },
  created() {
    this.$menuFn.setTitle(
      this.title[this.$route.params._field] + "-朱子文化·综合信息服务平台"
    );
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "portal-arti-page") {
        this.$menuFn.setTitle(
          this.title[this.$route.params._field] + "-朱子文化·综合信息服务平台"
        );
      }
      let contains = this.$loadRouteData(
        from,
        to,
        this.routeType,
        "page",
        "portal",
        false
      );
      if (this.routeWatch && contains) {
        this.$refs["refId"].clearData();
        this.meta.module = this.$route.params._module;
        this.meta.field = this.$route.params._field;
        this.$refs["refId"].loadData();
        this.filter.yicunType = "";
        this.selectedType = "";
      }
    }
  }
};
</script>
<style lange="sass" scoped>
.head-select {
  /* height: 110px; */
}
.address {
  float: left;
  font-size: 16px;
}
ul {
  list-style: none;
  margin-top: -5px;
  margin-left: -20px;
  display: inline-block;
}

li {
  min-width: 60px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  float: left;
  cursor: pointer;
  overflow: hidden;
  font-size: 16px;
  margin-right: 5px;
  margin: 5px;
}
ul li.selected {
  background-color: #ecb700;
  color: #fff;
}
ul li:hover {
  background-color: #ecb700;
  color: #fff;
}
ul li:active {
  background-color: #ecb700;
  color: #fff;
}
.font-size {
  font-size: 16px;
}
.el-input--small .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 60%;
}
.el-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 250px;
  margin-left: 20px;
}

.el-button--small {
  padding: 7px 15px;
  font-size: 12px;
  border-radius: 3px;
  margin-left: 20px;
}
</style>